import { ActionProps, TypeCommon } from "models/common";

export function createAction(type: string, payload?: TypeCommon): ActionProps {
  return { type, payload };
}
